import React, { useState } from "react";
import styles from "./closeAccountModal.module.css";
import { CgDanger } from "react-icons/cg";

const CloseAccountModal = ({ show, onClose, onConfirm, accountUsername }) => {
  const [typedUsername, setTypedUsername] = useState("");
  const [validInput, setValidInput] = useState(false);
  const [btnClicked, setBtnClicked] = useState(false);

  if (!show) return null;

  /**
   * Handle change of the username input field value
   */
  const handleUsernameChange = (event) => {
    setTypedUsername(event.target.value);
  };

  /**
   * Validate the entered username, and if valid - run the onConfirm function to close the account.
   */
  const handleConfirm = (event) => {
    setBtnClicked(true);

    if (typedUsername === accountUsername) {
      setValidInput(true);
      onConfirm();
      onClose();
    } else {
      setValidInput(false);
    }
  };

  return (
    <div className={styles.modalOverlay} onClick={onClose}>
      <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
        <h2>Confirmation</h2>
        <p className={styles.dangerIcon}>
          <CgDanger />
        </p>
        <p>Are you sure you want to close your account?</p>
        <div className={styles.modalText}>
          <p>
            The user {accountUsername} will be permanently deactivated, and you
            will lose access to your content.
          </p>
          <p>
            To close your account, enter your username and click on CLOSE
            ACCOUNT.
          </p>
        </div>

        <div className={styles.textInputWrapper}>
          <input
            type="text"
            placeholder="Username for closing account"
            required
            onChange={handleUsernameChange}
          />
        </div>

        <button className={styles.closeConfirmationBtn} onClick={handleConfirm}>
          CLOSE ACCOUNT
        </button>
        <button className={styles.cancelBtn} onClick={onClose}>
          Cancel
        </button>
        {btnClicked && !validInput && (
          <div className={styles.feedback}>
            Please enter your username to confirm you want to close your
            account.
          </div>
        )}
      </div>
    </div>
  );
};

export default CloseAccountModal;
